import React, { ChangeEvent } from 'react';

import { Button, Stack, TextField } from '@mui/material';

import { formatDateISO } from '~/services/TimeService';

type Props = {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  name?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  required?: boolean;
};

export default function UploadDateField({
  value,
  onChange,
  label = 'Date of Payment',
  name = 'date_of_payment',
  fullWidth,
  disabled,
  required,
}: Props) {
  const setToday = () => onChange(formatDateISO(new Date()));

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <TextField
        label={label}
        type="date"
        name={name}
        value={value}
        onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
        InputLabelProps={{ shrink: true }}
        fullWidth={fullWidth}
        disabled={disabled}
        required={required}
      />
      <Button type="button" variant="outlined" onClick={setToday} disabled={disabled}>
        Today
      </Button>
    </Stack>
  );
}
